import { FontSizes, TextColors } from '../types';
import { tailint } from '../utils';

const TEXT_VARIANTS = tailint({
  'heading-2': {
    size: 'text-[32px]/[48px]',
    color: 'text-secondary',
  },
  'heading-1': {
    size: 'text-[26px]/[39px]',
    color: 'text-secondary',
  },
  'title-2': {
    size: 'text-xl/[30px]',
    color: 'text-secondary',
  },
  'title-1': {
    size: 'text-lg/[27px]',
    color: 'text-primary',
  },
  'subtitle-2': {
    size: 'text-[17px]/[25px]',
    color: 'text-primary',
  },
  'subtitle-1': {
    size: 'text-base/[25px]',
    color: 'text-primary',
  },
  'body-2': {
    size: 'text-[15px]/[22px]',
    color: 'text-primary',
  },
  'body-1': {
    size: 'text-sm/[22px]',
    color: 'text-primary',
  },
  'caption-2': {
    size: 'text-[13px]/[19px]',
    color: 'text-neutral-500',
  },
  'caption-1': {
    size: 'text-xs/[19px]',
    color: 'text-neutral-500',
  },
}) satisfies {
  [v: string]: {
    size: FontSizes;
    color?: TextColors;
  };
};

const TEXT_INPUT_VARIANTS = {
  default: tailint([
    // inactive
    'border-neutral-300 bg-white',
    // hover
    'hover:border-neutral-400',
    // focus
    'focus-within:border-brand focus-within:hover:border-brand',
    'focus:border-brand focus:hover:border-brand',
  ]).join(' '),
  valid: tailint([
    // inactive
    'border-green-500 bg-white',
    'placeholder-shown:border-neutral-300 has-placeholder-shown:border-neutral-300', // shows the valid state only if it has value
    // hover
    'hover:border-green-500',
    'placeholder-shown:hover:border-neutral-400 has-placeholder-shown:hover:border-neutral-400', // shows the valid state only if it has value
    // focus
    'focus-within:border-green-500 focus-within:hover:border-green-500',
    'focus:border-green-500 focus:hover:border-green-500',
    'placeholder-shown:focus-within:border-brand placeholder-shown:focus-within:hover:border-brand', // shows the valid state only if it has value
    'placeholder-shown:focus:border-brand placeholder-shown:focus:hover:border-brand', // shows the valid state only if it has value
    'has-placeholder-shown:focus-within:border-brand has-placeholder-shown:focus-within:hover:border-brand', // shows the valid state only if it has value
    'has-placeholder-shown:focus:border-brand has-placeholder-shown:focus:hover:border-brand', // shows the valid state only if it has value
  ]).join(' '),
  error: tailint([
    // inactive
    'border-red-500 bg-white',
    'placeholder-shown:border-neutral-300 has-placeholder-shown:border-neutral-300', // shows the error state only if it has value
    // hover
    'hover:border-red-500',
    'placeholder-shown:hover:border-neutral-400 has-placeholder-shown:hover:border-neutral-400', // shows the error state only if it has value
    // focus
    'focus-within:border-red-500 focus-within:hover:border-red-500',
    'focus:border-red-500 focus:hover:border-red-500',
    'placeholder-shown:focus-within:border-brand placeholder-shown:focus-within:hover:border-brand', // shows the error state only if it has value
    'placeholder-shown:focus:border-brand placeholder-shown:focus:hover:border-brand', // shows the error state only if it has value
    'has-placeholder-shown:focus-within:border-brand has-placeholder-shown:focus-within:hover:border-brand', // shows the error state only if it has value
    'has-placeholder-shown:focus:border-brand has-placeholder-shown:focus:hover:border-brand', // shows the error state only if it has value
  ]).join(' '),
  disabled: tailint([
    // inactive
    'border-neutral-200 bg-neutral-100 text-neutral-400',
    // hover
    'hover:border-neutral-200',
  ]).join(' '),
};

export { TEXT_VARIANTS, TEXT_INPUT_VARIANTS };
